import { render } from "./AdminTabNav.vue?vue&type=template&id=ff9e3506"
import script from "./AdminTabNav.vue?vue&type=script&lang=js"
export * from "./AdminTabNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__